// extracted by mini-css-extract-plugin
module.exports = {"container":"KeepPlayingOptions_container__1r93t","autoPlayLabel":"KeepPlayingOptions_autoPlayLabel__3nzbI","switchContainer":"KeepPlayingOptions_switchContainer__2erXW"};